import { useGraphQLQuery } from '@betterment/graphql';

import {
  FourOhOneKStudentLoanMatchBenefitMessagesDocument,
  FourOhOneKStudentLoanMatchBenefitMessagesQuery,
  FourOhOneKStudentLoanMatchBenefitMessagesQueryVariables,
} from './graphql/query.fourOhOneKStudentLoanMatchBenefitMessages.generated';

export function useMessages({
  location,
}: {
  location: 'goal_overview_employer_match' | 'account_claim_contribution_setup_success';
}) {
  const query = useGraphQLQuery<
    FourOhOneKStudentLoanMatchBenefitMessagesQuery,
    FourOhOneKStudentLoanMatchBenefitMessagesQueryVariables
  >(FourOhOneKStudentLoanMatchBenefitMessagesDocument, { variables: { location } });

  return { loading: query.loading, messages: query.data?.fourOhOneKStudentLoanMatchBenefit?.messages || [] };
}
